import React from 'react';
import { SearchContainer, SearchInput, SearchIcon } from './SearchBar.styled';

const SearchBar = ({ value, onChange, placeholder = "Buscar..." }) => {
    return (
        <SearchContainer>
            <SearchIcon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                </svg>
            </SearchIcon>
            <SearchInput
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                aria-label="Buscar productos"
            />
        </SearchContainer>
    );
};

export default SearchBar;
